import { useQuery } from "@tanstack/react-query";
import { q } from "../api.ts";
import { ProductMark } from "./props.tsx";
import { Chip } from "./status.tsx";
import "./service-logos.css";

/** The same product identity in an inbox chip or a review's metadata. */
export function ProductLabel({ product, chip = false }: { product: { id: string; name: string; url?: string }; chip?: boolean }) {
  const products = useQuery({ ...q.products, enabled: product.url === undefined });
  const url = product.url ?? products.data?.find(p => p.id === product.id)?.url;
  const mark = <ProductMark productId={product.id} url={url} name={product.name} size={chip ? 12 : 16} />;
  return chip ? <Chip icon={mark}>{product.name}</Chip> : <span className="z-service-name">{mark}{product.name}</span>;
}
